function getSafeNumber(value) {
  const parsedValue = Number(value ?? 0);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function formatRoundedCompactValue(value, decimalPlaces) {
  const roundedValue = Number(Number(value).toFixed(decimalPlaces));

  if (!Number.isFinite(roundedValue)) {
    return "0";
  }

  return String(roundedValue);
}

export const UI_MACRO_DISPLAY_ORDER = Object.freeze([
  "protein",
  "carbs",
  "fats",
]);

export const UI_MACRO_SHORT_LABELS = Object.freeze({
  protein: "P",
  carbs: "C",
  fats: "F",
});

const UI_MACRO_SHORT_LABELS_ES = Object.freeze({
  ...UI_MACRO_SHORT_LABELS,
  fats: "G",
});

export function getUiMacroShortLabels(language = "en") {
  const normalizedLanguage = String(language ?? "").trim().toLowerCase();

  return normalizedLanguage.startsWith("es")
    ? UI_MACRO_SHORT_LABELS_ES
    : UI_MACRO_SHORT_LABELS;
}

export function getUiMacroShortLabel(key, language = "en") {
  return getUiMacroShortLabels(language)?.[key] ?? UI_MACRO_SHORT_LABELS[key] ?? "";
}

export function formatMacroValue(value) {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "0";
  }

  const safeValue = getSafeNumber(value);
  const absoluteValue = Math.abs(safeValue);

  if (absoluteValue < 0.05) {
    return "0";
  }

  const roundedTenths = Math.round((safeValue + Number.EPSILON) * 10) / 10;

  if (Math.abs(roundedTenths) >= 10) {
    return String(Math.round(safeValue));
  }

  return Number.isInteger(roundedTenths)
    ? String(roundedTenths)
    : roundedTenths.toFixed(1);
}

export function formatCalorieValue(value) {
  return String(Math.round(getSafeNumber(value)));
}

export function formatPercentageValue(value) {
  const normalizedValue = Number(value);

  if (!Number.isFinite(normalizedValue)) {
    return "0";
  }

  const roundedValue = Math.round((normalizedValue + Number.EPSILON) * 10) / 10;

  return Number.isInteger(roundedValue)
    ? String(roundedValue)
    : roundedValue.toFixed(1);
}

export function formatWholePercentageValue(value) {
  const normalizedValue = Number(value);

  if (!Number.isFinite(normalizedValue)) {
    return "0";
  }

  return String(Math.round(normalizedValue));
}

export function formatMicronutrientValue(value) {
  const normalizedValue = Number(value);

  if (!Number.isFinite(normalizedValue)) {
    return "0";
  }

  const absoluteValue = Math.abs(normalizedValue);

  if (absoluteValue === 0) {
    return "0";
  }

  if (absoluteValue < 1) {
    return formatRoundedCompactValue(normalizedValue, 2);
  }

  if (absoluteValue < 10) {
    return formatRoundedCompactValue(normalizedValue, 1);
  }

  return formatRoundedCompactValue(normalizedValue, 1);
}
